import React, { createContext, useState, useContext } from "react";
import { fetchAttemptQuestionsData } from "../services/service";

const AttemptedQuestionsContext = createContext();

function AttemptedQuestionsProvider({ children }) {
  const [attemptedQuestions, setAttemptedQuestions] = useState(null);

  const fetchAttemptedQuestions = async (examId) => {
    // if (attemptedQuestions) return;
    try {
      const AttemptedQuestionsData = await fetchAttemptQuestionsData(examId);

      setAttemptedQuestions(AttemptedQuestionsData.attempted_questions);
    } catch (error) {
      console.error("Error fetching Attempted Questions:", error);
    }
  };

  return (
    <AttemptedQuestionsContext.Provider
      value={{ attemptedQuestions, fetchAttemptedQuestions }}
    >
      {children}
    </AttemptedQuestionsContext.Provider>
  );
}

const useAttemptedQuestions = () => {
  return useContext(AttemptedQuestionsContext);
};

export { useAttemptedQuestions };
export default AttemptedQuestionsProvider;
